import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  Table, Text, Square, SquareContainer, PathContainer,
} from './styles';
import ImageComponent from '../../../../../../components/tree-test-modal/image-component';

const CustomTable = (props) => {
  const { branches } = props;
  const RESULT_TYPE = {
    'Direct Success': '#2DA545',
    'Indirect Success': '#A6FFB8',
    'Direct Failure': '#EC2C42',
    'Indirect Failure': '#FF8796',
  };
  const IMAGE_NAME = {
    forward: 'Forward',
    backward: 'Backward',
    sibling: 'Sibling',
  };

  const transformedPath = (text) => {
    const tokens = text
      .split(/\s(<|>|<->)\s/g)
      .map((token) => {
        switch (token) {
          case '>':
            return <ImageComponent imageName={IMAGE_NAME.forward} />;
          case '<':
            return <ImageComponent imageName={IMAGE_NAME.backward} />;
          case '<->':
            return <ImageComponent imageName={IMAGE_NAME.sibling} />;
          default:
            return token;
        }
      });

    return (
      <>
        Home
        <ImageComponent imageName={IMAGE_NAME.forward} />
        {tokens.map((t) => t)}
      </>
    );
  };

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Outcome</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Participant</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Path</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {!_.isEmpty(branches) && _.map(branches, (branch) => (
          <Table.Row>
            <SquareContainer>
              <Square resultType={RESULT_TYPE[branch.treeTestResult]} />
              {' '}
              {branch.treeTestResult}
            </SquareContainer>

            <Table.Cell>
              <Text>{branch.firstName}</Text>
            </Table.Cell>
            <Table.Cell>
              <PathContainer>
                {transformedPath(branch.treeTestPath)}
              </PathContainer>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      visitedPercentage: PropTypes.number,
      firstClickPercentage: PropTypes.number,
    }),
  ).isRequired,
};

export default CustomTable;
